import React from 'react'
// import Auther from '../../components/auth/auther'

const Signup = () => {
	return (
		// <Auther {...props}></Auther>
		<div>sign up</div>
	)
}

export default Signup
